module.exports = __webpack_public_path__ + "static/img/front-garden-wall-2026.bba65d9.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portfolio/front-garden-wall-2026.webp
// module id = Lkza
// module chunks = 0